






























































import Vue from "vue";
import store from "@/store";
import firebaseApp from "./main";

export default Vue.extend({
  name: "App",
  data: () => ({
    value: "Workout",
    overlay: false,
  }),
  mounted() {
    if (!this.signedIn) this.$router.push("/signUp");
    else if (this.$router.currentRoute.name !== "Workout")
      this.$router.push("/workout");
  },
  methods: {
    async signOut() {
      this.overlay = true;
      await firebaseApp
        .auth()
        .signOut()
        .then(() => {
          this.overlay = false;
          store.commit("userStore/setUserUID", null);
          store.commit("userStore/setUserData", null);
          this.$router.push("/signUp");
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
        });
    },
    changeRoute(routeName: string) {
      if (this.$router.currentRoute.name !== routeName)
        this.$router.push(`/${routeName}`);
    },
  },
  computed: {
    signedIn(): boolean {
      return store.getters["userStore/isUserSignedIn"];
    },
  },
});
